import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, FileText, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

const TermsPage = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/api/store/pages/terms`);
        if (response.data.success) {
          setContent(response.data.content || '');
          setLastUpdated(response.data.updated_at);
        }
      } catch (error) {
        console.error('Failed to fetch terms:', error);
        setContent('<p>Terms and Conditions content not yet configured.</p>');
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Header */}
      <div className="bg-slate-800/50 border-b border-slate-700">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Button
            onClick={() => navigate(-1)}
            variant="ghost"
            className="text-slate-400 hover:text-white"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-slate-800/50 rounded-xl border border-slate-700 p-8">
          <div className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-700">
            <FileText className="h-8 w-8 text-orange-400" />
            <div>
              <h1 className="text-2xl font-bold text-white">Terms and Conditions</h1>
              <p className="text-sm text-slate-400">Biggest Little CPR</p>
            </div>
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="h-8 w-8 animate-spin text-orange-400" />
            </div>
          ) : (
            <div 
              className="prose prose-invert prose-slate max-w-none
                prose-headings:text-white prose-headings:font-bold
                prose-h1:text-2xl prose-h2:text-xl prose-h3:text-lg
                prose-p:text-slate-300 prose-p:leading-relaxed
                prose-li:text-slate-300
                prose-strong:text-white
                prose-a:text-orange-400 prose-a:no-underline hover:prose-a:underline"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}

          {lastUpdated && (
            <p className="text-xs text-slate-500 mt-8 pt-4 border-t border-slate-700">
              Last updated: {new Date(lastUpdated).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
